// extracted by mini-css-extract-plugin
module.exports = {"heading":"news_heading__PlXni","colsContainer":"news_colsContainer__KIQhs"};